// extracted by mini-css-extract-plugin
module.exports = {"sidenav":"styles_sidenav__KBqiS","closebtn":"styles_closebtn__2wiyQ"};